module.exports = __webpack_public_path__ + "static/media/client-1.5b26701c.jpg";